/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RefillDialog.vue?vue&type=template&id=2332463f"
import script from "./RefillDialog.vue?vue&type=script&lang=js"
export * from "./RefillDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2332463f')) {
      api.createRecord('2332463f', component.options)
    } else {
      api.reload('2332463f', component.options)
    }
    module.hot.accept("./RefillDialog.vue?vue&type=template&id=2332463f", function () {
      api.rerender('2332463f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/RefillDialog.vue"
export default component.exports